export const inbox = {
  titles: {
    inbox: "صندوق الوارد",
    unifiedInbox: "صندوق الوارد الخاص بك، موحّدًا",
  },
  subtitles: {
    manageMessages: "أدِر الرسائل من قنوات الحجز الخاصة بك",
    unifiedDesc:
      "هنا سترى جميع المحادثات مع ضيوفك، بغضّ النظر عمّا إذا كانوا يكتبون من Airbnb أو Booking أو قناة أخرى.",
    subscribeHint:
      "اشترك لتفعيل صندوق الوارد الخاص بك وتبسيط تواصلك.",
    planOnly:
      "هذه الوحدة متاحة فقط لخطط {plans}.",
  },
  states: {
    notInstalledTitle: "وحدة الرسائل غير مثبّتة",
    notInstalledDesc:
      "ثبّت وحدة المراسلة للاتصال بقنوات الحجز الخاصة بك.",
    noChannelsTitle: "لا توجد قنوات متصلة",
    noChannelsDesc:
      "لاستخدام وحدة المراسلة، يجب أن تكون هناك قناة واحدة متصلة على الأقل (Booking.com، Airbnb).",
    noAccessTitle: "ليس لديك وصول إلى وحدة الرسائل",
  },
  actions: {
    installModule: "تثبيت وحدة الرسائل",
    configureChannel: "إعداد القناة",
  },
  toasts: {
    connectChannelRequiredTitle: "الاتصال مطلوب",
    connectChannelRequiredBody:
      "قم بتوصيل قناة حجز واحدة على الأقل لتثبيت وحدة الرسائل.",
  },
  errors: {
    notFoundPropertyOrUser: "لم يتم العثور على وحدة الإقامة أو المستخدم.",
    channelConnectGeneric:
      "خطأ في الاتصال بالقناة. يرجى المحاولة مرة أخرى.",
    generateTokenError: "خطأ في إنشاء الرمز",
  },
};
